import {ClientPlacement} from './clientPlacement.model';
import {Tag} from './tag.model';

export class ClientPlacementEvent {
    id: string;
    clientPlacement: ClientPlacement;
    eventTag: Tag;
    eventDate: string;
    externalId: string;

    constructor(clientPlacementEvent: any) {
        if (clientPlacementEvent) {
            this.id = clientPlacementEvent.id;
            this.clientPlacement = new ClientPlacement(clientPlacementEvent.clientPlacement);
            this.eventTag = new Tag(clientPlacementEvent.eventTag);
            this.eventDate = clientPlacementEvent.eventDate;
            this.externalId = clientPlacementEvent.externalId;
        }
    }
}
